<script setup>
useCustomMeta('top')
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const breadCrumbList = isWebViewFlag ? [] : getBreadCrumb('top')
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <div class="frame">
        <RiverMap />
      </div>
      <template #main-bottom>
        <RiverCurrent />
        <RiverSearch />
        <HorizontalStackAd
          v-if="!isWebViewFlag"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <div
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
        <RiverLinks />
        <TopicList />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
